import React, {useRef, useState} from "react";
import {InputTextarea} from "primereact/inputtextarea";
import {Button} from "primereact/button";
import {Accordion, AccordionTab} from "primereact/accordion";
import {InputText} from "primereact/inputtext";
import {Toast} from 'primereact/toast';
import LicenseGeneratorService from "./LicenseGenerator.service";

const LicenseGenerator = () => {
    const toast = useRef(null);
    let [licenseName ,setLicenseName] = useState("");
    let [licenseInput, setLicenseInput] = useState("{\n" +
        "  \"guid\": \"EC2A43AF-3A30-4B4F-FE5A-837D343F1481\",\n" +
        "  \"type\":\"Trial\",\n" +
        "  \"trail_days\":30,\n" +
        "  \"license_expiry_date\": 1664303400000,\n" +
        "  \"machine_count\":500,\n" +
        "  \"volume_count\":100,\n" +
        "  \"appaware_ec2_count\":0,\n" +
        "  \"mysql_appaware_ec2_count\":0,\n" +
        "  \"wild_card\": true,\n" +
        "  \"aws_enabled\":true,\n" +
        "  \"vmware_enabled\":false,\n" +
        "  \"size_limit\":\"10\",\n" +
        "  \"size_based_check\":false,\n" +
        "  \"vm_count\":0,\n" +
        "  \"appaware_vm_count\":0,\n" +
        "  \"exec_sql\":\"SELECT\",\n" +
        "  \"user_count\":\"10\",\n" +
        "  \"uploadDate\":\"2020-10-02\"\n" +
        "}");
    let [generatingLicense, setGeneratingLicense] = useState(false);

    const onGenerateClickHandler = (e) => {
        e.preventDefault();
        if(!licenseName || !licenseInput) {
            return ;
        }
        setGeneratingLicense(true);
        try {
            let licenseJSONInput = JSON.parse(licenseInput);
            LicenseGeneratorService({licenseName, licenseJSONInput}).then((response) => {
                toast.current.show({severity: 'success', summary: 'Success', detail: 'License Generated successfully.'});
            }, (error) => {
                toast.current.show({severity: 'error', summary: 'Error', detail: 'Failed to generate License. Please Check the logs!'});
            }).finally(() => {
                setGeneratingLicense(false);
            });
        } catch (e) {
            console.log(e);
        }
    };
    const licenseInputChangeHandler = (e) => {
        setLicenseInput(e.target.value);
    };
    const licenseNameChangeHandler = (e) => {
        setLicenseName(e.target.value);
    };

    return(
        <React.Fragment>
            <Toast ref={toast} />
            <Accordion>
                <AccordionTab header= "License Generator">
                    <div className={'generate-card mx-25 align-content-center'}>
                        <div className="p-fluid grid">
                            <div className="field col-12 md:col-4">
                                <span className="p-float-label">
                                    <InputText id="licenseName" value={licenseName} onChange={licenseNameChangeHandler}
                                               autoFocus="autofocus" required/>
                                    <label htmlFor="licenseName">License Name</label>
                                </span>
                                {!licenseName && <small className="p-error">Please enter a license name.</small>}
                            </div>
                            <div className="field col-12 md:col-4">
                                <span className="p-float-label">
                                    <InputTextarea id="licenseInput" value={licenseInput} onChange={licenseInputChangeHandler}
                                                   rows={10} cols={30} required/>
                                    <label htmlFor="licenseInput">License Input JSON</label>
                                    {!licenseInput &&
                                        <small className="p-error">Please enter valid license input in JSON Format.</small>}
                                </span>
                            </div>
                            <div className={'mt-5 align-content-center'}>
                                <Button label="Generate" className= "p-button-info" icon="pi pi-check" loading={generatingLicense}
                                        disabled={!licenseInput} onClick={onGenerateClickHandler} />
                            </div>
                        </div>
                    </div>
                </AccordionTab>
            </Accordion>
        </React.Fragment>
    );
}

export default LicenseGenerator;
